import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RaceDetailDto, RunnerStatusEnum, runnerStatusLabel, TeamDto } from '@aoe/client';
import { SnackBarService } from 'src/app/core/services/snack-bar.service';
import { TeamService } from 'src/app/core/services/team.service';

@Component({
  selector: 'aoe-edit-team-form',
  templateUrl: './edit-team-form.component.html',
  styleUrl: './edit-team-form.component.scss',
  standalone: false
})
export class EditTeamFormComponent implements OnInit {

  @Input()
  team?: TeamDto;

  @Input()
  teamsRaces!: RaceDetailDto[];

  formGroup!: FormGroup;

  runnerStatusLabel = runnerStatusLabel;
  runnerStatus = Object.values(RunnerStatusEnum);

  readonly teamNameFC = new FormControl<string | null>(null, [Validators.required, Validators.minLength(3)]);
  readonly clubFC = new FormControl<string | null>(null);
  readonly statutTeamFC = new FormControl<RunnerStatusEnum>(RunnerStatusEnum.NOT_STARTED, [Validators.required]);
  readonly categoryTeamFC = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(3), Validators.minLength(3)]);
  readonly raceId = new FormControl<string | null>(null, [Validators.required]);
  readonly categoryLabelTeamFC = new FormControl<string | null>(null);
  readonly chipTeamFC = new FormControl<number | null>(null, Validators.pattern('[0-9]+'));
  readonly bibTeamFC = new FormControl<number | null>(null, [Validators.required, Validators.pattern('[0-9]+')]);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly teamService: TeamService,
    private readonly snackbarService: SnackBarService
  ) {

  }

  ngOnInit(): void {
    this.formGroup = this.initFormGroup();

    if (this.team) {
      this.setFcValues();
    }
  }

  private initFormGroup() {

    if (this.teamsRaces.length === 1) {
      this.raceId.setValue(this.teamsRaces[0].id);
      this.raceId.disable();
    }

    return this.formBuilder.group({
      category: this.categoryTeamFC,
      categoryLabel: this.categoryLabelTeamFC,
      chip: this.chipTeamFC,
      name: this.teamNameFC,
      raceId: this.raceId,
      status: this.statutTeamFC,
    });
  }

  private setFcValues() {
    if (this.team) {
      this.teamNameFC.setValue(this.team.name);
      this.statutTeamFC.setValue(this.team.status);
      this.categoryLabelTeamFC.setValue(this.team.category.label);
      this.categoryTeamFC.setValue(this.team.category.code);
      this.chipTeamFC.setValue(this.team.chip)
      this.bibTeamFC.setValue(this.team.bib)
      this.clubFC.setValue(this.team.club)
    }
    this.formGroup.updateValueAndValidity();
  }

  submit() {
    if (this.formGroup.valid)
      if (this.team) {
        this.teamService.updateTeam(this.formGroup.getRawValue(), this.team.id).subscribe({
          next: () => {
            alert('team updated')
          },
          error: () => {
            this.snackbarService.openErrorSnackBar('Echec de la mise à jour de votre équipe')
          }
        })
      } else {
        this.teamService.createTeam(this.formGroup.getRawValue()).subscribe({
          next: () => {
            alert('team saved')
          },
          error: () => {
            this.snackbarService.openErrorSnackBar('Echec de l\'enregistrement de votre équipe')
          }
        })
      }


  }

}
